module.exports = __webpack_public_path__ + "img/daizy_agriculture.fbc55490.jpg";